var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wf-swatch-room-gallery" }, [
    _c("div", { staticClass: "wf-swatch-room-gallery-room" }, [
      _vm.items.length > 0
        ? _c("img", {
            staticClass: "wf-swatch-room-gallery-room-image",
            attrs: {
              src: _vm.$helpers.getRoomSceneThumbnailImageUrlFromAlgoliaResult(
                _vm.items[_vm.selectedItemIndex]
              ),
              alt: ""
            }
          })
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "wf-swatch-room-gallery-swatches" },
      [
        _vm._l(_vm.items, function(item, itemIndex) {
          return _c(
            "li",
            {
              key: item.sellingStyleNumber,
              staticClass: "wf-swatch-room-gallery-swatch-item"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedItemIndex,
                    expression: "selectedItemIndex"
                  }
                ],
                staticClass: "wf-swatch-room-gallery-radio",
                attrs: {
                  id:
                    "wf-swatch-room-gallery-radio-" +
                    _vm.collectionCode +
                    "-" +
                    item.sellingStyleNumber,
                  name: "wf-swatch-room-gallery-" + _vm.collectionCode + "[]",
                  type: "radio"
                },
                domProps: {
                  value: itemIndex,
                  checked: _vm._q(_vm.selectedItemIndex, itemIndex)
                },
                on: {
                  change: function($event) {
                    _vm.selectedItemIndex = itemIndex
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "wf-swatch-room-gallery-label",
                  attrs: {
                    for:
                      "wf-swatch-room-gallery-radio-" +
                      _vm.collectionCode +
                      "-" +
                      item.sellingStyleNumber
                  }
                },
                [
                  _c("div", { staticClass: "wf-swatch-room-gallery-swatch" }, [
                    _c("img", {
                      staticClass: "wf-swatch-room-gallery-swatch-image",
                      attrs: {
                        src: _vm.$helpers.getColorThumbnailImageUrl(
                          item.sellingStyleNumber,
                          item.colors[0].colorNumber
                        ),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "wf-swatch-room-gallery-swatch-title description"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(item.sellingStyleName) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          )
        }),
        _vm._v(" "),
        _c("li", { staticClass: "align-self-center" }, [
          _c(
            "a",
            {
              staticClass: "btn",
              attrs: {
                href: _vm.$helpers.getCollectionOverviewUrl(_vm.collectionCode)
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$resourceString["common.seeMore"]) +
                  "\n        "
              ),
              _c("span", {
                staticClass: "png-icon png-icon-icons-glyph--k-arrow-right-sm"
              })
            ]
          )
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }